import React from 'react'

import Separator from '../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Text from '../../../../components/pdf/Text'
import View from '../../../../components/pdf/View'

const LastPage = () => {
  return (
    <View pageBreakAfter>
      <Grid direction="column" align="start">
        <Col>
          <Image src="/pdfs/sannygold/logo.jpg" maxWidth={100} />
        </Col>
      </Grid>
      <Separator weight={6} />
      <Text bold align="center" color="#938953" size={18}>
        Opções disponíveis:
      </Text>
      <Separator weight={20} />
      <Grid direction="row">
        <Col width="50%" gutter={5}>
          <Image src="/pdfs/sannygold/cabin-10.jpg" />
        </Col>
        <Col width="50%">
          <Image src="/pdfs/sannygold/cabin-04.jpg" />
        </Col>
      </Grid>
      <Grid direction="row">
        <Col width="50%" gutter={5}>
          <Image src="/pdfs/sannygold/cabin-08.jpg" />
        </Col>
        <Col width="50%">
          <Image src="/pdfs/sannygold/cabin-02.jpg" />
        </Col>
      </Grid>
      <Grid direction="row">
        <Col width="50%" gutter={5}>
          <Image src="/pdfs/sannygold/cabin-06.jpg" />
        </Col>
        <Col width="50%">
          <Image src="/pdfs/sannygold/cabin-01.jpg" />
        </Col>
      </Grid>
    </View>
  )
}

export default LastPage
